import { render, staticRenderFns } from "./navbarCategories.pug?vue&type=template&id=797609df&lang=pug&external"
import script from "./navbarCategories.js?vue&type=script&lang=js&external"
export * from "./navbarCategories.js?vue&type=script&lang=js&external"
import style0 from "./navbarCategories.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797609df')) {
      api.createRecord('797609df', component.options)
    } else {
      api.reload('797609df', component.options)
    }
    module.hot.accept("./navbarCategories.pug?vue&type=template&id=797609df&lang=pug&external", function () {
      api.rerender('797609df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navbarCategories/index.vue"
export default component.exports